import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import Gauche from "../home/gauche";
import { format } from "date-fns";
import fr from "date-fns/locale/fr";
import ReactPaginate from "react-paginate";
import { baseApiUrl } from "../../../services/api";

function Header3() {
  const [currentPage, setCurrentPage] = useState(0);
  const [itemsPerPage] = useState(5);
  const [informations, setInformations] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const navigate = useNavigate();

  // Calculer les informations à afficher sur la page actuelle
  const offset = currentPage * itemsPerPage;
  const currentInformations = informations.slice(offset, offset + itemsPerPage);

  const formatDate = (dateString) => {
    try {
      const date = new Date(dateString);
      return format(date, "dd MMMM yyyy", { locale: fr });
    } catch {
      return "Date invalide";
    }
  };

  // Fonction nécessaire pour la pagination
  const handlePageClick = (data) => {
    setCurrentPage(data.selected);
    // Scroll back to top when changing page
    window.scrollTo(0, 0);
  };

  useEffect(() => {
    setIsLoading(true);
    baseApiUrl
      .get("/information/liste")
      .then((response) => {
        if (response.data && Array.isArray(response.data)) {
          // Filtrer et trier les informations
          const preparedInformations = response.data
            .filter(item => item && typeof item === 'object')
            .sort((a, b) => new Date(b.created || 0) - new Date(a.created || 0));

          setInformations(preparedInformations);
        } else {
          setInformations([]);
        }
      })
      .catch((error) => {
        console.error("Erreur lors de la récupération des actualités:", error);
        setInformations([]);
      })
      .finally(() => {
        setIsLoading(false);
      });
  }, []);

  return (
    <div className="main-content-wrapper bg-light">
      <div className="container-fluid px-4 py-4">
        <div className="row">
          {/* Colonne principale avec Gauche */}
          <div className="col-lg-8">
            <Gauche />
          </div>

          {/* Colonne latérale avec actualités - avec position sticky */}
          <div className="col-lg-4">
            <div 
              className="sidebar-container bg-white rounded shadow-sm p-4"
              style={{
                position: "sticky",
                top: "20px", // Distance from the top of the viewport
                maxHeight: "calc(100vh - 40px)", // Viewport height minus margins (top and bottom)
                overflowY: "auto", // Enable scrolling within the sidebar if content is too tall
                zIndex: 100 // Ensure it appears above other content if necessary
              }}
            >
              <div className="section-title mb-4">
                <h3 style={{ color: '#FF8C00', borderBottom: '2px solid #FF8C00', paddingBottom: '10px' }}>
                  Actualités Récentes
                </h3>
              </div>

              {isLoading ? (
                <div className="text-center py-4">
                  <p>Chargement des actualités...</p>
                </div>
              ) : informations.length === 0 ? (
                <div className="text-center py-4">
                  <p>Aucune actualité disponible pour le moment.</p>
                </div>
              ) : (
                <div className="actualites-list">
                  {currentInformations.map((info) => (
                    <div
                      className="actualite-item mb-4 pb-4"
                      key={info.id}
                      style={{ borderBottom: '1px solid #eee' }}
                    >
                      <div className="row g-0">
                        <div className="col-4">
                          <div className="actualite-image">
                            <img
                              src={info.image
                                ? baseApiUrl.defaults.baseURL + `/image/${info.image}`
                                : "/assets/img/placeholder-image.jpg"}
                              alt={info.titre}
                              className="img-fluid rounded"
                              style={{ objectFit: 'cover', height: '80px', width: '100%' }}
                            />
                          </div>
                        </div>
                        <div className="col-8 ps-3">
                          <div className="date mb-1" style={{ fontSize: '0.8rem', color: '#666' }}>
                            <i className="fa fa-calendar-alt me-1"></i> {formatDate(info.created)}
                          </div>
                          <h5 className="mb-0" style={{ fontSize: '1rem', fontWeight: 'bold' }}>
                            <a
                              href="#"
                              onClick={(e) => {
                                e.preventDefault();
                                navigate(`/information/${info.id}`);
                              }}
                              style={{ color: '#333', textDecoration: 'none' }}
                              className="hover-text-primary"
                            >
                              {info.titre}
                            </a>
                          </h5>
                        </div>
                      </div>
                    </div>
                  ))}
                </div>
              )}

              {/* Pagination */}
              {informations.length > itemsPerPage && (
                <div className="pagination-container mt-4 d-flex justify-content-center">
                  <ReactPaginate
                    previousLabel={<i className="fa fa-angle-left"></i>}
                    nextLabel={<i className="fa fa-angle-right"></i>}
                    breakLabel={"..."}
                    pageCount={Math.ceil(informations.length / itemsPerPage)}
                    marginPagesDisplayed={1}
                    pageRangeDisplayed={5}
                    onPageChange={handlePageClick}
                    containerClassName={"pagination"}
                    pageClassName={"page-item"}
                    pageLinkClassName={"page-link"}
                    previousClassName={"page-item"}
                    previousLinkClassName={"page-link"}
                    nextClassName={"page-item"}
                    nextLinkClassName={"page-link"}
                    breakClassName={"page-item"}
                    breakLinkClassName={"page-link"}
                    activeClassName={"active"}
                  />
                </div>
              )}

              {/* Call to action */}
              <div className="cta-box mt-5 p-4 rounded text-center" style={{ backgroundColor: '#FFF8E1', borderLeft: '5px solid #FFD700' }}>
                <h4 style={{ color: '#FF8C00' }}>Restez informé !</h4>
                <p className="mb-3">Suivez nos actualités pour ne rien manquer</p>
                <button
                  className="btn"
                  onClick={() => navigate('/informations')}
                  style={{ backgroundColor: '#FF8C00', color: 'white', padding: '8px 16px', borderRadius: '5px' }}
                >
                  Toutes les actualités
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Header3;